import React from 'react'
import MonthDropdown from "../MonthDropdown/MonthDropdown";
import InputContainer from "../Layouts/InputContainer"
import InlineForm from "../Layouts/InlineForm"

export default class MonthForm extends React.Component{
	constructor(props){
		super(props)
		
		this.date = new Date()
		
		this.state = {
			year: this.date.getFullYear(),
			month: this.date.getMonth(),
			yearError: ''
		}
	}
	
	componentDidMount() {
		this.submitNewRange()
	}
	
	monthChange(newMonth){
		this.setState({
			month: newMonth
		})
	}
	
	yearChange(event){
		let year = event.target.value
		let error = ''
		
		if(year.length < 4 || year.length > 4) {
			error = ": 4 numbers only"
		}
		
		this.setState({
			year: event.target.value,
			yearError: error
		})
	}
	
	submitNewRange(){
		const {month, year, yearError} = this.state
		
		if(yearError.length > 0){
			return
		}
		
		let formatMonth = parseInt(month) + 1
		
		const endOfMonth = (new Date(year, formatMonth, 0)).getDate()
		
		formatMonth = formatMonth < 10 ? '0'+formatMonth : formatMonth
		
		let fromDate = `${year}${formatMonth}01`
		let toDate = `${year}${formatMonth}${endOfMonth}`
		
		this.props.onSubmitCallback(fromDate, toDate)
	}
	
	render(){
		return(
			<InlineForm>
				<MonthDropdown
					onChangeCallback={this.monthChange.bind(this)}
				/>
				<InputContainer title={`Year ${this.state.yearError}`}>
					<input
						type={"number"}
						maxLength={4}
						onChange={this.yearChange.bind(this)}
						value={this.state.year}
						className={'year-input'}
					/>
				</InputContainer>
				<button
					type={"button"}
					onClick={this.submitNewRange.bind(this)}
				>Submit</button>
			</InlineForm>
		)
	}
}